// extracted by mini-css-extract-plugin
export var centerText = "_cl-8";
export var container = "_cl-0";
export var doughnutContainer = "_cl-7";
export var legend = "_cl-a";
export var legendItemColorDisplay = "_cl-b";
export var legendItemLabel = "_cl-d";
export var legendItemValue = "_cl-c";
export var lg = "_cl-5";
export var maxWidth = "_cl-9";
export var md = "_cl-4";
export var responsive = "_cl-6";
export var sm = "_cl-3";
export var xs = "_cl-2";
export var xxs = "_cl-1";